<template>
  <page-article :page-title="title">
    <ul class="pb-5">
      <li>
        （一）業師諮詢服務主要提供生涯方向、進修、就業、履歷健檢及模擬面試等職涯相關議題討論。過程中，業師會依照個人經驗及專長提供相關建議或引導探索解決職涯問題。
      </li>
      <li>
        （二）業師諮詢不收取任何費用。
      </li>
      <li>
        （三）每個諮詢時段是50分鐘，依據您選擇的諮詢主題進行討論，若在諮詢過程當中想變更討論主題請直接與業師討論。
      </li>
      <li>
        （四）如需取消預約請直接登入職涯發展網後即可取消報名，若已超過報名時間無法線上取消請來電02-2737-6125。
      </li>
    </ul>
  </page-article>
</template>
<script>
import pageArticle from '~components/pages/Article'
export default {
  name: 'WorkplaceConsentContent',
  components: {
    pageArticle
  },
  data () {
    return {
      title: ''
    }
  }
}
</script>
